import { Component, OnInit } from '@angular/core'
import { BannerConfig } from '@se-po/shared-data-access-models'
import { AnalyticsService, BannerDisplayService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-minor-account',
  templateUrl: './minor-account.component.html',
  styleUrls: ['./minor-account.component.scss'],
  standalone: false,
})
export class MinorAccountComponent implements OnInit {

  public footerYear = new Date().getFullYear()
  public logo: string
  public bannerConfig: BannerConfig

  constructor(
    public analyticsService: AnalyticsService,
    private bannerDisplayService: BannerDisplayService,
    public setupService: SetupBarService
  ) { }

  public ngOnInit() {
    this.logo = `${environment.uiThemes}/assets/latest/images/sportsengine-logo-color-black.svg`
    this.setupService.title = 'Create Household'
    this.bannerDisplayService.bannerConfig$.subscribe(res => this.bannerConfig = res)
  }
}
